<template>
  <div class="tabs">
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-1"
      :checked="todaysData.length > 0 && true"
      v-if="todaysData.length > 0"
    />
    <label class="label" for="tab-1" v-if="todaysData.length > 0">{{
      todays_date
    }}</label>
    <div class="panel">
      <timelineJadualMobile :data="todaysData" v-if="todaysData.length > 0" />
      <div class="w-100" v-else>
        <p class="no-record-title">Tiada rekod dijumpai</p>
      </div>
    </div>
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-2"
      v-if="tomorrowsData.length > 0"
    />
    <label class="label" for="tab-2" v-if="tomorrowsData.length > 0"
      >Esok</label
    >
    <div class="panel">
      <timelineJadualMobile
        :data="tomorrowsData"
        v-if="tomorrowsData.length > 0"
      />
      <div class="w-100" v-else>
        <p class="no-record-title">Tiada rekod dijumpai</p>
      </div>
    </div>
    <input
      class="input"
      name="tabs"
      type="radio"
      id="tab-3"
      :checked="todaysData.length === 0 && true"
    />
    <label class="label" for="tab-3">Saluran Radio</label>
    <div class="panel">
      <div class="w-100 px-0 mt-2">
        <RadioNasional />
        <RadioTempatan />
        <RadioNegeri />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import timelineJadualMobile from "./timelineJadualMobile.vue";
import tvCard from "../cards/v2/tvCard.vue";
import RadioNasional from "../../components/carousel/radio/v2/radioNasional.vue";
import RadioNegeri from "../../components/carousel/radio/v2/radioNegeri.vue";
import RadioTempatan from "../../components/carousel/radio/v2/radioTempatan.vue";
export default {
  name: "vodTabsMobile",
  props: ["todaysData", "tomorrowsData", "todays_date"],
  data: function() {
    return {
      tv_list: [],
      hover: false,
    };
  },
  components: {
    RadioNasional,
    RadioNegeri,
    RadioTempatan,
    tvCard,
    timelineJadualMobile,
  },

  created: function() {
    // this.$store.dispatch("fetchRTMTVList", { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0;
  font-family: "Bree Serif", serif;
  font-size: 36px;
}
p {
  margin-top: 20px;
  margin-bottom: 0;
  padding: 0;
  font-size: 20px;
  line-height: 1.5;
}
.tabs {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 700px;
  background: #000;
  box-shadow: 0 48px 80px -32px rgba(0, 0, 0, 0.3);
}
.input {
  position: absolute;
  opacity: 0;
}
.label {
  width: 100%;
  padding: 16px 8px;
  background: #000;
  cursor: pointer;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  transition: background 0.1s, color 0.1s;
}
.label:hover {
  background: #000;
}
.label:active {
  background: #000;
}
.input:focus + .label {
  z-index: 1;
}
.input:checked + .label {
  border-bottom: 2px solid #d9e021;
}
@media (max-width: 768px) {
  .label {
    width: auto;
  }
}
.panel {
  width: 100%;
  display: none;
  padding: 8px 0;
  position: relative;
  overflow: hidden;
}
@media (max-width: 768px) {
  .panel {
    order: 99;
  }
}
.input:checked + .label + .panel {
  display: block;
}
</style>
